module.exports = __webpack_public_path__ + "img/white_logo.376f7d72.png";